import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : stats templates
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Label, Statistic, Loader, Icon } from 'semantic-ui-react';
//~ import jpath from 'jsonpath'
// ---Framework imports
import { Sel, Actions } from 'uix/registries';
import log from 'uix/logging';
import { keys, dict, flatten, isString, filterItems, get, items, uniq, isNumber, isInteger } from 'ldash';
import { formatNumber } from 'uix/i18n';
import { useSelector, useEffect, useState, useSummaries } from 'uix/hooks';
// ---Local imports
// ---Exports
const ScalarStat = ({ value, label, size, floated, icon, language })=>{
    let props = {
        size
    };
    if (floated) {
        props.floated = floated;
    }
    value = formatNumber(value, language);
    //XXX: maybe make the spacing between icon and value configurable
    if (icon) {
        return /*#__PURE__*/ _jsxs(Statistic, {
            ...props,
            children: [
                /*#__PURE__*/ _jsxs(Statistic.Value, {
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            name: icon
                        }),
                        " ",
                        value
                    ]
                }),
                /*#__PURE__*/ _jsx(Statistic.Label, {
                    children: label
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Statistic, {
        value: value,
        label: label,
        ...props
    });
};
const Stat = ({ get: query, label, icon = null, floated = false, size })=>{
    let i18n = useSelector(Sel.i18n);
    let stats = useSelector(Sel.statistics);
    //~ jpath.query()
    if (!stats || !query) {
        return /*#__PURE__*/ _jsx(Loader, {
            size: size,
            active: true,
            inline: true
        });
    }
    let [table, row, column] = query.split('.');
    let props = {
        size,
        floated,
        icon,
        language: i18n._language
    };
    if (table && (row == '*' || !column)) {
        let data = null;
        if (!column) {
            data = get(stats, `${table}.${row}`, {});
        } else {}
        let rowStats = filterItems(data, (k, v)=>true).map(([label, value])=>/*#__PURE__*/ _jsx(ScalarStat, {
                value: value,
                label: i18n.get(label),
                ...props
            }, label));
        return /*#__PURE__*/ _jsx(Statistic.Group, {
            size: size,
            children: rowStats
        });
    } else {
        let value = get(stats, `${table}.${row}.${column}`, 0);
        return ScalarStat({
            value,
            label,
            ...props
        });
    }
};
const StatisticFetcher = ({ elements, dname })=>{
    let getTable = (query)=>query && query.split('.')[0];
    let neededSummaries = uniq(elements.map((e)=>getTable(e.attrib.get)).filter((e)=>e));
    useSummaries(neededSummaries, dname);
    return null;
};
export const statistic = {
    match: ({ tag })=>tag == 'Statistic',
    build: ({ attrib })=>/*#__PURE__*/ _jsx(Stat, {
            ...attrib,
            children: "123"
        }),
    completion: ({})=>{
        return {
            '!top': [
                'Statistic'
            ],
            Statistic: {
                attrs: {
                    get: [
                        'domain.',
                        'datatype.',
                        'metadata.'
                    ],
                    floated: [
                        'left',
                        'right'
                    ],
                    icon: [
                        'play'
                    ],
                    size: [
                        'mini',
                        'tiny',
                        'small',
                        'large',
                        'huge'
                    ]
                }
            }
        };
    },
    init: ({ keys, ddata })=>keys.byTag['Statistic'] && /*#__PURE__*/ _jsx(StatisticFetcher, {
            dname: ddata.name,
            elements: keys.byTag['Statistic']
        })
};
